<template>
  <div>
    <div class="mrB10" />
    <sui-grid
      ref="grid"
      :dataset="'dsMessageResourceMass'"
      :columns="defaultGridData.columns"
      :multiselect="true"
      :showDisplayCountControl="false"
    />
    <div class="comm_btn_wrap">
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="onClickSelectMessageresource"
      >
        {{ $t("MSG_BTN_NEW") }}
      </sui-button>
      <sui-button
        v-permission:delete="pageId"
        type="button"
        class="comm_btn_border"
        :disabled="checkMetaSave"
        @click="onClickDelete"
      >
        {{ $t("MSG_BTN_DEL") }}
      </sui-button>
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="onClickIdDuplicationCheck"
      >
        {{ $t("MSG_BTN_DPCT_CHCK") }}
      </sui-button>
      <sui-button
        v-permission:update="pageId"
        type="button"
        class="comm_btn_solid"
        :disabled="checkMetaSave"
        @click="onClickSave"
      >
        {{ $t("MSG_BTN_SAVE") }}
      </sui-button>
    </div>
  </div>
</template>
<script>
import p01 from './PGE_CMU_00003_P01';
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';

const CODE_KEYS = ['COD_MDLE', 'COD_MSG_RESO_TYPE'];
const gridEditorFactory = utils.getGridCellFactory();

export default {
  name: 'PGE_CMU_00003_T03', // eslint-disable-line vue/name-property-casing
  pname: 'PGE_CMU_00003',
  extends: BasePage,
  props: {
    massdataList: {
      type: String,
      default: '',
    },
    pageId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      pageTitle: this.$t('MSG_TXT_BK_RGST'), // eslint-disable-line vue/name-property-casing,
      pageName: this.$t('MSG_TXT_MSG_RESO_BK_RGST'),
      messageResourceTypeAdapter: '',
      isShownPopupMasteNew: false,
      components: { p01 },
      localdata: [],
      massdata: [],
      moduleAdapter: '',
      codes: {
        COD_MDLE: [{ key: ' ', label: this.$t('MSG_TXT_SEL') }],
        COD_MSG_RESO_TYPE: [{ key: ' ', label: this.$t('MSG_TXT_SEL') }],
      },
      defaultGridData: {
        columns: [
          {
            text: this.$t('MSG_TXT_MSG_RESO_VAL'),
            datafield: 'multiLanguageMassContent',
            editable: false,
          }, {
            text: this.$t('MSG_TXT_DTC_MSG_VAL'),
            datafield: 'multiLanguageContent',
            editable: false,
          }, {
            text: this.$t('MSG_TXT_VRFC_RSULT'),
            datafield: 'massCheck',
            editable: false,
            cellclassname: this.massCheckcellClass,
          }, {
            text: this.$t('MSG_TXT_MDLE'),
            datafield: 'moduleCode',
            width: 120,
            createwidget: (row, column, value, htmlElement) => {
              gridEditorFactory.createCellSelect(row, column, value, htmlElement,
                {
                  optionList: this.codes.COD_MDLE,
                  checkDisabledFunction: this.checkDisabledFunction,
                },
                this.dsMessageResourceMass, this.$refs.grid);
            },
            initwidget(row, column, value, htmlElement) {
              gridEditorFactory.refreshCell(row, column, value, htmlElement);
            },
          }, {
            text: this.$t('MSG_TXT_TYPE'),
            datafield: 'messageResourcesTypeCode',
            width: 120,
            createwidget: (row, column, value, htmlElement) => {
              // const disableFlag    = (row.bounddata.massCheck  != '-' ? true : false);
              const componentInstance = gridEditorFactory.createCellSelect(row, column, value, htmlElement,
                {
                  optionList: this.codes.COD_MSG_RESO_TYPE,
                  checkDisabledFunction: this.checkDisabledFunction,
                },
                this.dsMessageResourceMass, this.$refs.grid);
              const instance = componentInstance.getComponentInstance();

              instance.$on('select', event => {
                const newMessageResourcesId = `MSG_${event}_`;
                const rowIndex = componentInstance.getDatasetIndex();

                componentInstance.dataset.setData(rowIndex, 'messageResourcesId', newMessageResourcesId);
                componentInstance.dataset.setData(rowIndex, 'duplicationCheck', '');
              });
            },
            initwidget(row, column, value, htmlElement) {
              gridEditorFactory.refreshCell(row, column, value, htmlElement);
            },
          }, {
            text: this.$t('MSG_TXT_MSG_RESO_ID'),
            datafield: 'messageResourcesId',
            createwidget: (row, column, value, htmlElement) => {
              const componentInstance = gridEditorFactory.createCellTextField(row, column, value, htmlElement,
                {
                  trim: true,
                  checkDisabledFunction: this.checkDisabledFunction,
                },
                this.dsMessageResourceMass, this.$refs.grid);
              const instance = componentInstance.getComponentInstance();

              instance.$on('blur', () => {
                const rowIndex = componentInstance.getDatasetIndex();

                componentInstance.dataset.setData(rowIndex, 'duplicationCheck', '');
              });

              instance.$on('keyup', () => {
                const datasetEventData = utils.clone(componentInstance.dataset.data);
                const rowIndex = componentInstance.getDatasetIndex();
                const datasetEventRowData = datasetEventData[rowIndex];
                const searchFieldNewText = instance.$refs.refInput.value;

                instance.searchFieldOldText = utils.isEmpty(instance.searchFieldOldText)
                  ? datasetEventRowData.messageResourcesId
                  : instance.searchFieldOldText;

                if (!utils.isEngNum_(searchFieldNewText) && !utils.isEmpty(searchFieldNewText)) {
                  utils.messageBox('warning', this.$t('MSG_ALT_ONLY_ENGLISH_NUMBER'), null, () => {
                    componentInstance.dataset.setData(rowIndex, 'messageResourcesId', instance.searchFieldOldText);

                    this.gridSetFocus(rowIndex, 'messageResourcesId');
                  });
                } else {
                  instance.searchFieldOldText = searchFieldNewText;
                }
              });
            },
            initwidget(row, column, value, htmlElement) {
              gridEditorFactory.refreshCell(row, column, value, htmlElement);
            },
          }, {
            text: this.$t('MSG_BTN_ID_VRFC'),
            datafield: 'duplicationCheck',
            editable: false,
          }],
      },
      checkMetaSave: utils.checkMetaSave(),
    };
  },
  watch: {
    // data 변경시 특정 함수를 호출 해야 하는 경우(async 등)
    massdataList(massDataList) {
      this.massDataGridInput(massDataList);
    },
  },
  mounted() {
    // DOM이 document에 append된 상태, 실제 element에 접근 가능 (this.$el or this.$refs)
    // 주로 데이터 패치 등을 함
    this.loadCode();
  },
  methods: {
    loadCode() {
      return http.mergeCodeList(this.$options.name, CODE_KEYS, this.codes);
    },
    /**
     * 중복 체크
     */
    onClickIdDuplicationCheck() {
      const gridList = this.dsMessageResourceMass.data;
      if (gridList.length == 0) {
        utils.messageBox('alert', null, this.$t('MSG_ALT_NOT_SEL_ITEM'));
        return;
      }

      let gridDupleIdList = utils.clone(gridList);

      if (utils.findIndex(gridList, o => utils.isEmpty(o.messageResourcesId)) > -1) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_MSG_RESO_ID')));
        return false;
      }

      utils.remove(gridDupleIdList, index => utils.isEqual(index.duplicationCheck, 'N/A'));
      gridDupleIdList = utils.join(utils.map(gridDupleIdList, 'messageResourcesId'), '|');

      const queryParams = {
        messageResourceMassList: gridDupleIdList,
      };

      http.request(this.$options.pname, 'DTS_CMU_00025', {
        query: queryParams,
      }).then(res => {
        const list = utils.clone(this.dsMessageResourceMass.data);
        utils.forEach(gridList, obj => {
          const a = utils.findIndex(res.data,
            o => utils.isEqual(o.messageResourcesId.replace(/[\t\s]/g, ''),
              obj.messageResourcesId.replace(/[\t\s]/g, '')));
          const rowIndex = utils.findIndex(this.dsMessageResourceMass.data,
            o => utils.isEqual(o['dataset-row-id'], obj['dataset-row-id']));

          if (obj.duplicationCheck !== 'N/A') {
            list[rowIndex].duplicationCheck = a > -1 ? 'fail' : 'pass';
          }
        });

        // this.dsMessageResourceMass.setRawData([]);
        this.dsMessageResourceMass.setRawData(list);
      });

      return null;
    },
    /**
     * GRID 글자 색 추가.
     */
    massCheckcellClass(row, columnfield, value) {
      if (value !== '-') {
        return 'RE_errortext';
      }
      return '';
    },
    /**
     * 신규 팝업 호출
     */
    onClickSelectMessageresource() {
      this.$emit('onPopupCall');
    },
    /**
     * 신규 팝업 CALLBACK
     */
    massDataGridInput(value) {
      const valueSplitList = value.split('|');

      const queryParams = {
        messageResourceValueList: value,
      };

      http.request(this.$options.pname, 'DTS_CMU_00023', {
        query: queryParams,
      }).then(res => {
        this.massdata = [];
        utils.forEach(valueSplitList, obj => {
          const a = utils.findIndex(res.data, o => utils.isEqual(o.multiLanguageContent.replace(/[\t\s]/g, ''),
            obj.replace(/[\t\s]/g, '')));

          if (a > -1) {
            res.data[a].multiLanguageMassContent = obj;
            res.data[a].massCheck = this.$t('MSG_TXT_RGST_DAPP'); // 등록불가
            res.data[a].duplicationCheck = 'N/A';
            this.massdata.push(res.data[a]);
          } else {
            const defaultRow = {
              multiLanguageMassContent: obj,
              multiLanguageContent: '-',
              massCheck: '-',
              moduleCode: '',
              messageResourcesTypeCode: '',
              messageResourcesId: 'MSG_',
              duplicationCheck: '',
              langId: 'ko',
            };
            this.massdata.push(defaultRow);
          }
        });
        this.dsMessageResourceMass.setRawData(this.massdata);
      });
    },
    /**
     * 삭제
     */
    onClickDelete() {
      if (!(this.dsMessageResourceMass.getSelectedIndexes().length > 0)) {
        //utils.messageBox('warning', this.$t('MSG_ALT_NOT_SEL_ITEM')); // 선택 된 항목이 없습니다.
        utils.messageBox('alert', null, this.$t('MSG_ALT_NOT_SEL_ITEM'));
        return false;
      }
      utils.messageBox('confirm', this.$t('MSG_ALT_IS_DEL_DATA'), '', () => {
        this.dsMessageResourceMass.deleteRows(this.dsMessageResourceMass.getSelectedIndexes());
        this.dsMessageResourceMass.clearSelection();
      });

      return null;
    },
    /**
     * 저장
     */
    onClickSave() {
      if (!(this.dsMessageResourceMass.getSelectedIndexes().length > 0)) {
        //utils.messageBox('warning', this.$t('MSG_ALT_NOT_SEL_ITEM')); // 선택 된 항목이 없습니다.
        utils.messageBox('alert', null, this.$t('MSG_ALT_NOT_SEL_ITEM'));
        return false;
      }
      const messageResourcesMassList = this.dsMessageResourceMass.data;
      const dataParams = {
        messageResourcesMassList,
      };

      if (!this.validCheck(messageResourcesMassList)) return false; // null 값 체크

      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), '', () => { // 저장하시겠습니까?
        http.request(this.$options.pname, 'DTS_CMU_00024', {
          data: dataParams,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'));
        });
      });

      return null;
    },
    /**
     * 입력 체크
     */
    validCheck(messageResourcesMassList) {
      let flag = true;

      utils.forEach(messageResourcesMassList, (obj, key) => {
        const regType = new RegExp(`^MSG_${obj.messageResourcesTypeCode}_[A-Z0-9_]*$`);

        if (utils.isEmpty(utils.trim(obj.moduleCode))) {
          // {0} 행의 모듈코드를 선택하세요.
          utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_ROW_SELECT_MODULE'), key + 1));
          flag = false;
          return false;
        }
        if (utils.isEmpty(utils.trim(obj.messageResourcesTypeCode))) {
          // {0} 행의 메시지자원 유형을 선택하세요.
          utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_ROW_SELECT_MSG_TYPE'), key + 1));
          flag = false;
          return false;
        }
        if (utils.isEmpty(obj.messageResourcesId)) {
          // {0} 행의 메시지ID를 선택하세요.
          utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_ROW_INPUT_MSG_ID'), key + 1));
          flag = false;
          return false;
        }
        if (!regType.test(obj.messageResourcesId)) {
          // {0} 행의 메시지ID 형식이 잘못되었습니다.
          utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_ROW_WRONG_FORMAT'), key + 1));
          flag = false;
          return false;
        }
        if (utils.isEmpty(obj.duplicationCheck)) {
          // 중복 체크 해주세요.
          utils.messageBox('warning', this.$t('MSG_ALT_SELT_DPCT_CHK'));
          flag = false;
          return false;
        }
        if (utils.isEqual(obj.duplicationCheck, 'fail')) {
          // ID검증 fail항목이 존재하면 저장할 수 없습니다.
          utils.messageBox('warning', this.$t('MSG_ALT_FAIL_CANNOT_SAVE'));
          flag = false;
          return false;
        }

        return true;
      });
      return flag;
    },
    gridSetFocus(rowIndex, datafield) {
      this.$refs.grid.$refs.grid.ensurerowvisible(rowIndex);

      const editor = this.$refs.grid.getCellEditor(rowIndex, datafield);

      if (editor) {
        editor.getComponentInstance().setFocus();
      }
    },
    /**
     * grid disabled Function
     */
    checkDisabledFunction(rowData) {
      return !utils.isEqual(rowData.massCheck, '-');
    },
  },
  datasets: [{
    id: 'dsMessageResourceMass',
    type: 'local',
    data: 'massdata',
    datafields: [
      { type: 'string', name: 'checkBox', map: 'checkBox' },
      { type: 'string', name: 'multiLanguageContent', map: 'multiLanguageContent' },
      { type: 'string', name: 'multiLanguageMassContent', map: 'multiLanguageMassContent' },
      { type: 'string', name: 'massCheck', map: 'massCheck' },
      { type: 'string', name: 'moduleCode', map: 'moduleCode' },
      { type: 'string', name: 'messageResourcesTypeCode', map: 'messageResourcesTypeCode' },
      { type: 'string', name: 'messageResourcesId', map: 'messageResourcesId' },
      { type: 'string', name: 'duplicationCheck', map: 'duplicationCheck' },
      { type: 'string', name: 'langId', map: 'langId' },
    ],
  }],
};
</script>
<style scoped>
</style>
